<template>
    <transition name="modal-window">
        <div class="modal-window">
            <div class="modal-window__wrapper">
                <div class="modal-window__container">
                    <button class="modal-window__close" @click="$emit('close')">
                        x
                    </button>

                    <slot></slot>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
    export default {
        name: 'ModalWindow',
        mounted() {
            document.body.classList.add('no-scroll');
        },
        beforeDestroy() {
            document.body.classList.remove('no-scroll');
        }
    }
</script>

<style lang="less">
    .modal-window {
        position: fixed;
        z-index: 9998;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, .5);
        display: table;
        transition: opacity .3s ease;

    &__wrapper {
        display: table-cell;
        vertical-align: middle;
    }

    &__container {
        width: 300px;
        box-sizing: border-box;
        margin: 0 auto;
        padding: 20px 30px;
        background-color: #fff;
        border-radius: 2px;
        box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
        transition: all .3s ease;
        font-family: Helvetica, Arial, sans-serif;
        position: relative;
        max-height: 80%;
        overflow: scroll;
    }

    &__close {
        border: none;
        position: absolute;
        top: 10px;
        right: 10px;
        font-size: 20px;
        transition: transform .5s ease-in;

    &:focus {
        outline: none;
        transform: rotate(180deg);
     }
    }
    }

    .modal-window-enter {
        opacity: 0;
    }

    .modal-window-leave-active {
        opacity: 0;
    }

    .modal-window-enter .modal-window__container,
    .modal-window-leave-active .modal-window__container {
        -webkit-transform: scale(1.1);
        transform: scale(1.1);
    }

    .no-scroll {
        height: 100%;
        overflow: hidden;
    }
</style>



// WEBPACK FOOTER //
// src/components/ModalWindow.vue